import ComponentHeader from 'app/shared/ui/ComponentHeader';
import {ProductSelectionEditorProps, ProductSelectionEditor} from 'app/pages/DiscountEditor/components/ProductSelection';
import { getProductListState, getUnitFilter, getProductFilter, getAllProductsBasedOnCurrentSchool, canEditApplicableProducts, getSelectedProductMissingSchoolHints } from 'app/pages/DiscountEditor/modules/ProductSelection';
import { Action } from 'app/pages/DiscountEditor/actionTypes';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import * as actions from 'app/pages/DiscountEditor/actions';
import { ProductFilter } from 'app/shared/model/ProductFilter';
import { getSectionError } from 'app/pages/DiscountEditor/modules/Editor';
import { SaveDiscountErrorCategory } from 'app/shared/model/SaveDiscountResultDto';
import { UnitsFilter } from 'app/shared/model/ProductUnitFilter';
import { Alert } from 'antd';

type ApplicableProductsSelectionEditorProps = ProductSelectionEditorProps & {
    canEdit: boolean;
};

const ApplicableProductsSelectionEditor = (props: ApplicableProductsSelectionEditorProps) => {
    const { canEdit, ...editorProps } = props;
    return (
    <div style={{ marginBottom: 16, background: '#fff', border: '1px solid #f0f0f0', borderRadius: '4px' }}>
        <ComponentHeader text="Applicable products" />
        <div style={{ padding: '0 16px 16px' }}>
            {!canEdit && (
                <Alert
                    type="info"
                    showIcon
                    style={{ marginBottom: 12 }}
                    title="Select a division, at least one school, and dates"
                    description="The applicable products list is available after a division, at least one school, and dates in the Dates section are selected."
                />
            )}
            <div
                aria-disabled={!canEdit}
                style={{
                    opacity: canEdit ? 1 : 0.45,
                    pointerEvents: canEdit ? 'auto' : 'none',
                    userSelect: canEdit ? 'auto' : 'none',
                }}
            >
                <ProductSelectionEditor {...editorProps} />
            </div>
        </div>
    </div>
    );
}

function mapStateToProps(state: any, ownProps: {}) : Partial<ApplicableProductsSelectionEditorProps> {
    const unitsFilter = getUnitFilter(state);
    const filter = getProductFilter(state);

    let props : Partial<ApplicableProductsSelectionEditorProps> = {
        productFilter: filter,
        errorMessage: getSectionError(state, SaveDiscountErrorCategory.ApplicableProducts)||getSectionError(state, SaveDiscountErrorCategory.Units),
        allowUnitFilter: true,
        productOptions: getAllProductsBasedOnCurrentSchool(state, filter),
        productsListState: getProductListState(state, filter),
        productOfferingHints: getSelectedProductMissingSchoolHints(state, filter),
        unitFilter: unitsFilter,
        canEdit: canEditApplicableProducts(state),
    }

    return props;
}

function mapDispatchToProps(dispatch: ThunkDispatch<any, any, Action>) : Partial<ProductSelectionEditorProps> {
    return {
        changeProductFilter: function(filter: ProductFilter) {
            dispatch(actions.changeProductFilter(filter));
        },

        changeUnitFilter: function(filter: UnitsFilter) {
            dispatch(actions.changeUnitFilter(filter));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ApplicableProductsSelectionEditor as any);
